import React, { useEffect, useState } from 'react';
import { API, authHeaders } from '../utils/helpers';

// ── Customer feedback on the ticket window (25 Oct, feedback step 4) ────────
//
// Under the ticket's quotes: what this customer said about THIS ticket (once
// it is Done & Paid and they answered), and what they said LAST time, on an
// earlier ticket, so whoever is at the counter knows "scored us 4 last time"
// before the bike is back on the stand. Everyone who can open the ticket sees
// the scores; the comment and the follow-up need the `reviews` permission
// (server/routes/feedback.js /for-ticket), because a comment can name a tech.
// Shows nothing when there is nothing to show.

const tone = (n) => (n <= 6 ? '#e74c3c' : n <= 8 ? '#e6a23c' : '#27ae60');
const day = (iso) => { try { return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (_) { return ''; } };

export default function TicketFeedback({ ticketId, customerId, T }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    let live = true;
    setD(null);
    const q = customerId ? `?customerId=${encodeURIComponent(customerId)}` : '';
    fetch(`${API}/api/feedback/for-ticket/${encodeURIComponent(ticketId)}${q}`, { credentials: 'include', headers: authHeaders() })
      .then(r => (r.ok ? r.json() : null))
      .then(x => { if (live) setD(x); })
      .catch(() => {});
    return () => { live = false; };
  }, [ticketId, customerId]);

  if (!d || (!d.ticket && !d.lastTime)) return null;
  const line = (x, label) => {
    if (!x) return null;
    let what;
    if (x.score != null) what = null;
    else if (x.status === 'sent') what = `Asked by ${x.channel === 'sms' ? 'text' : 'email'} ${day(x.sentAt)}, no answer yet`;
    else if (x.status === 'scheduled') what = `Will be asked ${day(x.dueAt)}`;
    else if (x.status === 'skipped') what = `Not asked${x.skipReason ? `: ${x.skipReason}` : ''}`;
    else return null;
    return (
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 0', borderTop: `1px solid ${T.border}` }}>
        <span style={{ fontSize: 12, color: T.textSub, minWidth: 84 }}>{label}</span>
        {x.score != null ? (
          <div style={{ flex: 1, fontSize: 12.5, color: T.text }}>
            <strong style={{ color: '#fff', background: tone(x.score), borderRadius: 6, padding: '1px 7px', marginRight: 8 }}>{x.score}/10</strong>
            {day(x.answeredAt)}{label === 'Last time' && x.ticketId ? `, ticket #${x.ticketId}` : ''}
            {x.google && <span style={{ color: '#27ae60', marginLeft: 8 }}>opened Google review</span>}
            {x.comment ? <div style={{ fontStyle: 'italic', marginTop: 4 }}>“{x.comment}”</div> : null}
            {x.followup ? <div style={{ color: T.textSub, marginTop: 4 }}>Followed up by {x.followup.by}: {x.followup.note}</div>
              : x.needsCall ? <div style={{ color: '#e74c3c', marginTop: 4 }}>Nobody has logged a call yet (Reviews)</div> : null}
          </div>
        ) : <span style={{ flex: 1, fontSize: 12.5, color: T.textSub }}>{what}</span>}
      </div>
    );
  };
  return (
    <div style={{ marginTop: 14, border: `1px solid ${T.cardBorder || T.border}`, borderRadius: 10, padding: '12px 14px' }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: T.textSub, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>Customer feedback</div>
      {line(d.ticket, 'This ticket')}
      {line(d.lastTime, 'Last time')}
    </div>
  );
}
